import React from 'react';
import { InstagramIcon, MessageCircleIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { INSTAGRAM_URL, LOGO_URL, WHATSAPP_URL } from '../../data/links';
export function Footer() {
  const {
    t
  } = useLanguage();
  const socials = [{
    href: WHATSAPP_URL,
    label: 'WhatsApp',
    Icon: MessageCircleIcon
  }, {
    href: INSTAGRAM_URL,
    label: 'Instagram',
    Icon: InstagramIcon
  }];
  return <footer className="border-t border-black/[0.06] bg-white" data-id="element-151" data-mp="1mgnykw38a95y">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-5 px-5 py-8 sm:flex-row md:px-6" data-id="element-152" data-mp="1hhulh4rusk6b">
        <div className="flex items-center gap-2.5" data-id="element-153" data-mp="1w6r4fwvg7hlp">
          <img src={LOGO_URL} alt="" className="h-6 w-6 rounded-full" data-id="element-154" data-mp="1rf9337pijf07" />
          <span className="text-xs font-semibold tracking-[0.2em] text-graphite" data-id="element-155" data-mp="1rd61rriwtzg6">PROFUMIND</span>
        </div>
        <p className="text-xs text-subtle" data-id="element-156" data-mp="13nbqhee8oiy1">{t.footer.rights}</p>
        <div className="flex items-center gap-2" data-id="element-157" data-mp="ypsdsix6we87">
          {socials.map(({
          href,
          label,
          Icon
        }) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="grid h-9 w-9 place-items-center rounded-full text-subtle transition-colors duration-150 ease-out hover:bg-canvas hover:text-graphite" data-id="element-158" data-mp="1ehkgom5uzvck">
              <Icon className="h-4 w-4" data-id="element-159" data-mp="vj7xe7l8h539" />
            </a>)}
        </div>
      </div>
    </footer>;
}